import { InjectionToken } from '@angular/core';

export const ACTIONS_COLUMN_NAME = new InjectionToken<string>('VIRTUAL_SCROLL_ACTIONS_COLUMN_NAME');
export const SELECT_COLUMN_NAME = new InjectionToken<string>('VIRTUAL_SCROLL_SELECT_COLUMN_NAME');
export const COLUMN_DEFAULT_WIDTH = new InjectionToken<number>(
  'VIRTUAL_SCROLL_COLUMN_DEFAULT_WIDTH',
);
export const SELECT_COLUMN_DEFAULT_WIDTH = new InjectionToken<number>(
  'VIRTUAL_SCROLL_SELECT_COLUMN_DEFAULT_WIDTH',
);
export const ACTIONS_COLUMN_DEFAULT_WIDTH = new InjectionToken<number>(
  'VIRTUAL_SCROLL_ACTIONS_COLUMN_DEFAULT_WIDTH',
);
